export default __webpack_public_path__ + "static/media/img_20.df2fb43a.webp";